import axios from 'axios';

const logNonException = (level = 'info', message, context, fingerprint) => {
    if (window.Raven) {
        window.Raven.captureMessage(message, {
            level: (level === 'warn') ? 'warning' : level,
            fingerprint: fingerprint ? ['{{ default }}'] + fingerprint : undefined,
            extra: context
        });
    }

    window && window.console && window.console[level] && window.console[level](message);
};

export const logError = (ex, context, fingerprint) => {
    if (window.Raven) {
        window.Raven.captureException(ex, {
            fingerprint: fingerprint ? ['{{ default }}'] + fingerprint : undefined,
            extra: context
        });
        
        
        
    }

    window && window.console && window.console.error && window.console.error(ex);
};

export const logWarning = (message, context, fingerprint) => {
    logNonException('warn', message, context, fingerprint);
};

export const logInfo = (message, context, fingerprint) => {
    logNonException('info', message, context, fingerprint);
};

export const reportPageLoadError = async (errorName, error = '', errorInfo = '') => {
    try {
        const url = `${window.location.origin}/store-v2/error-log/`;
        const path = window.location.pathname;
        const queryParams = window.location.search;
        const ReduxState = window._getSanitizedState ? window._getSanitizedState() : 'Unavailable';
        const sessionKey = ReduxState?.session?.sessionKey;
        
        const ravenBreadcrumbs = (window.customBreadcrumbs || []).slice();

        
        let serializedError = error;
        if (error instanceof Error) {
            serializedError = {
                stack: error.stack
            };
        }
        const requestData = {
            errorName,
            path,
            queryParams,
            serializedError,
            errorInfo,
            ReduxState,
            sessionKey,
            ravenBreadcrumbs
        };
        
        
        await axios.post(url, requestData, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    } catch (err) {
        
    }
    return 0;
};

export const logAxiosError = (error) => {
    if (error.response) {
        
        const fingerprint = [error.response.status];
        error.message = `${error.message} - ${error.response.status}`;

        if (error.request) {
            
            
            fingerprint.push(error.request.responseURL);
            error.message = `${error.message} - ${error.request.responseURL}`;
        }

        logError(error, {
            data: error.response.data,
            status: error.response.status,
            headers: error.response.headers
        }, fingerprint);
        reportPageLoadError('Error in logAxiosError', error, {
            data: error.response.data,
            status: error.response.status,
            headers: error.response.headers
        });
    } else {
        logError(error, {
            message: error.message
        });
        reportPageLoadError('Error in logAxiosError', error, {
            message: error.message
        });
    }
};
